import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const Home1Icon = createSvgIcon(
  <>
    <title></title>
    <g className="nc-icon-wrapper" fill="none">
      <path
        d="M1.25 14.25l15-12 15 12"
        stroke="#222222"
        strokeMiterlimit="10"
      />
      <path
        d="M5.25 15.25v15h22v-15"
        stroke="#222222"
        strokeLinecap="square"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
